import { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { updateLocaleInUrl, standardizeLocale, getWidgetDimensions } from '@utils/airbnb'
import { Container } from '@mch-group/uikit-components'
import styled from 'styled-components'

export default function AirbnbEventWidget({ moduleName, id, abw_url, abw_currency }) {
  const [isClient, setIsClient] = useState(false)
  const [widgetUrl, setWidgetUrl] = useState(abw_url)
  const [dimensions, setDimensions] = useState({ width: 375, height: 997 })

  useEffect(() => {
    setIsClient(true)
    let cookieLocale = Cookies.get('mfpLocale') || 'en'
    cookieLocale = standardizeLocale(cookieLocale)
    setWidgetUrl(updateLocaleInUrl(abw_url, cookieLocale, abw_currency))
    const updateDimensions = () => {
      const width = window.innerWidth
      setDimensions(getWidgetDimensions(width))
    }
    updateDimensions()
    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [abw_currency, abw_url])

  if (!isClient) return null

  return (
    <StyledContainer>
      <Container className='px-5 px-lg-8 px-md-7'>
        <iframe
          src={widgetUrl}
          width='100%'
          height={dimensions.height}
          style={{ border: 'none' }}
          loading='lazy'
          title='Airbnb Event Widget'
          className={`${moduleName?.toLowerCase()}-module`}
          id={id}
        />
      </Container>
    </StyledContainer>
  )
}

// match breakpoints in app/src/utils/airbnb.ts
const StyledContainer = styled(Container)`
  @media (min-width: 375px) and (max-width: 439px) {
    padding-bottom: 28px;
  }

  @media (min-width: 440px) and (max-width: 949px) {
    padding-bottom: 47px;
  }

  @media (min-width: 950px) and (max-width: 1127px) {
    padding-bottom: 69px;
  }

  @media (min-width: 1128px) and (max-width: 1439px) {
    padding-bottom: 69px;
  }

  @media (min-width: 1440px) and (max-width: 1879px) {
    padding-bottom: 69px;
  }

  @media (min-width: 1880px) {
    padding-bottom: 15px;
  }
`
